import { render, staticRenderFns } from "./add-media-modal.vue?vue&type=template&id=45928e31&scoped=true"
import script from "./add-media-modal.vue?vue&type=script&lang=js"
export * from "./add-media-modal.vue?vue&type=script&lang=js"
import style0 from "./add-media-modal.vue?vue&type=style&index=0&id=45928e31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45928e31",
  null
  
)

export default component.exports